// extracted by mini-css-extract-plugin
export default {"container":"YS-z","title":"ZS-z","link":"_S-z"};